import { render, staticRenderFns } from "./main-header-search.vue?vue&type=template&id=3ef612c9&scoped=true"
import script from "./main-header-search.vue?vue&type=script&lang=js"
export * from "./main-header-search.vue?vue&type=script&lang=js"
import style0 from "./main-header-search.vue?vue&type=style&index=0&id=3ef612c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef612c9",
  null
  
)

export default component.exports